import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import Dropdown from '@sv-support-sdk/ui-components/src/components/Controls/Dropdown';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';
import BreadcrumbsItem from './BreadcrumbsItem';
import Options from '../../Lists/Options';
import useMobileDetect from '../../../hooks/useMobileDetect';

import css from './style.module.scss';

export interface IBreadcrumb {
  text: string;
  link?: string;
  isLast?: boolean;
}

interface IProps {
  items: IBreadcrumb[];
  className?: string;
}

const Breadcrumbs: FC<IProps> = ({ items, className }) => {
  const navigate = useNavigate();
  const isMobile = useMobileDetect();

  const OPTIONS_COUNT_FROM_THE_END = isMobile ? 1 : 2;
  const withDropdown = isMobile ? items.length > 2 : items.length > 4;

  const startOptions = withDropdown ? [items[0]] : [];
  const dropdownOptions = withDropdown ? items.slice(1, -OPTIONS_COUNT_FROM_THE_END) : [];
  const otherOptions = withDropdown ? items.slice(-OPTIONS_COUNT_FROM_THE_END) : items;

  const dropdownHandler = ({ link }: IBreadcrumb) => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <div className={classNames(css.breadcrumbs, className)}>
      {startOptions.map((item, index) => (
        <BreadcrumbsItem key={index} item={item} />
      ))}
      {withDropdown && (
        <div className={css.breadcrumbs__item} key="dropdown">
          <Dropdown
            options={dropdownOptions}
            value={null}
            trackBy="link"
            label="text"
            width="32"
            onSelect={dropdownHandler}
            controlClassName={css.breadcrumbs__dropdown__control}
            // @ts-ignore - expect error
            OptionsComponent={Options}
          >
            <div className={css.breadcrumbs__button}>
              <span className={classNames(css.breadcrumbs__icon, css.breadcrumbs__icon_size_16)}>
                <Icon id="24--more-horiz-filled" />
              </span>
            </div>
          </Dropdown>
          <div className={css.breadcrumbs__icon}>
            <Icon id="20--chevron-right" />
          </div>
        </div>
      )}
      {otherOptions.map((item, index) => (
        <BreadcrumbsItem key={index} item={item} />
      ))}
    </div>
  );
};

export default Breadcrumbs;
